import { AppConst } from '@anypromo/shared/utils/AppConst'

export const isDef = <T>(val: T): val is NonNullable<T> =>
  val !== undefined && val !== null

// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (val: unknown): val is Function =>
  typeof val === 'function'

// export const isFunction = (val: unknown): val is Function =>
//   typeof val === 'function'

export const isNumeric = (val: string | number): val is number =>
  typeof val === 'number' || /^\d+(\.\d+)?$/.test(val)

export const isObject = (val: unknown): val is Record<any, any> =>
  val !== null && typeof val === 'object'

export function isMobile(value: string): boolean {
  value = value.replace(/[^-|\d]/g, '')
  return (
    /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value)
  )
}

export const isEmptyObject = <T>(val: T): val is NonNullable<T> => {
  if (!val) return false
  // if (isArray(obj)) return obj.length == 0;
  for (const k in val) {
    return false
  }
  return true
}

export const isEmail = (value: string): boolean => {
  return /^\w+([+-.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)
}

export const isDate = (value: string, formart: string): boolean => {
  let regex = /^\d{2}\/\d{2}\/\d{4}$/ // mm/dd/yyyy (默认格式)
  switch (formart.toLowerCase()) {
    case 'mm/dd/yyyy':
      regex = /^\d{2}\/\d{2}\/\d{4}$/
      break
    case 'yyyy-mm-dd':
      regex = /^\d{4}-\d{2}-\d{2}$/
      break
  }

  if (!regex.test(value))
    return false

  const d = new Date(value)
  let isInvalidDate = d.toString() !== 'Invalid Date'
  if (!isInvalidDate)
    return false

  if (d < AppConst.DateNull || d > AppConst.DateMax)
    return false
  else
    return true
}


export const isXXSAttack = (value: string): boolean => {
  return /^(?=.*?<)(?=.*?>).+$/.test(value)
}